// PermissionBlock — D1: the permission a clinic can lawfully act on, printed word for word in a
// bordered box titled "What you're signing". One block per named person; it re-renders as the
// name is typed (a placeholder stands in until then). The text is counsel's, from rraCopy
// (permissionText), byte-identical to what the signed PDF prints:
//   • signer 'subject'         — the person with the disability signs (themselves, or an adult
//                                household member signing their own): first person throughout.
//   • signer 'parent_guardian' — a parent signs for a minor: references to the child are
//                                re-voiced, the parent's own acts stay first person, and the box
//                                ends with "I'm signing as {Name}'s parent or legal guardian."
//
//   cd apps/web && npx tsx --test src/components/rra/PermissionBlock.test.ts

import { PERMISSION_BOX_TITLE, permissionText } from '@/lib/rraCopy';

export function PermissionBlock(props: {
  /** The named person; '' until typed (the box shows the placeholder). */
  verifierName: string;
  signer: 'subject' | 'parent_guardian';
  /** The person with the disability (used only for 'parent_guardian'). */
  subjectName: string;
  /** Any covered item is an animal request → "my animal at home". */
  needIsAnimal: boolean;
  officePhone: string;
}): React.JSX.Element {
  const text = permissionText({
    verifierName: props.verifierName,
    signer: props.signer,
    subjectName: props.subjectName,
    needIsAnimal: props.needIsAnimal,
    officePhone: props.officePhone,
  });
  return (
    <section
      aria-label={PERMISSION_BOX_TITLE}
      style={{
        border: '1px solid var(--border-strong, var(--border))',
        borderRadius: 'var(--radius-md)',
        padding: 'var(--space-4)',
        background: 'var(--bg-alt)',
      }}
    >
      <h3 style={{ margin: '0 0 var(--space-2)', fontSize: 'var(--text-base)' }}>{PERMISSION_BOX_TITLE}</h3>
      <p style={{ margin: '0 0 var(--space-2)' }}>{text.lead}</p>
      {/* The design system's base styles strip list markers; counsel's bullets keep theirs. */}
      <ul style={{ margin: '0 0 var(--space-2)', paddingLeft: 'var(--space-5)', listStyle: 'disc' }}>
        {text.bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
      {text.guardianLine ? <p style={{ margin: 0 }}>{text.guardianLine}</p> : null}
    </section>
  );
}
